import {Avatar, Stack, ToggleButton, ToggleButtonGroup, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import type {ClosedOnDays} from "../../firebase/index.js";
import {red_900} from "../../reusables/js/APXTheme.js";


export const DAYS_OF_WEEK = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];


export interface DaysButtonGroupProps {
	  header?: string;
	  valueArray: string[];
	  onChange: (selectedDays: string[])=>void;
}


export default function DaysButtonGroup({valueArray, header, onChange}: DaysButtonGroupProps) {
	  const [values, setValues] = useState(valueArray);
	  
	  useEffect(() => {
			 setValues(valueArray);
	  }, [valueArray]);
	  
	  const onToggleButtonGroupChange = (event, values) => {
			 setValues(values);
			 onChange(values);
	  };
	  
	  return (
				 <Stack spacing={0.5}>
						<Typography variant={"caption"} align={"center"}> {header} </Typography>
						<ToggleButtonGroup onChange={onToggleButtonGroupChange} value={values}>
							  {
									 DAYS_OF_WEEK.map((day, index) => (
												<ToggleButton key={index} value={day} style={{backgroundColor: values.includes(day) ? red_900 : "inherit"}}>
													  {day.substring(0, 1)}
												</ToggleButton>
									 ))
							  }
						</ToggleButtonGroup>
				 </Stack>
	  );
}


export interface ClosedOnDaysOfWeekProps {
	  closedOnDaysOfWeek: ClosedOnDays;
}


export function ClosedOnDaysOfWeek({closedOnDaysOfWeek}: ClosedOnDaysOfWeekProps) {
	  return (
				 <>
						<Stack direction="row" spacing={0.25}>
							  {DAYS_OF_WEEK.map((DDD, index) => (
										 <Avatar key={index}
													sx={{
														  width: 16,
														  height: 16,
														  backgroundColor: closedOnDaysOfWeek[DDD] ? red_900 : "inherit",
														  color: "white",
														  fontSize: "0.6rem",
														  fontWeight: "bold",
														  textAlign: "center",
														  alignContent: "center",
														  border: "2px solid white"
													}}>
												{DDD.substring(0, 1)}
										 </Avatar>
							  ))}
						</Stack>
				 </>
	  );
}